module.exports = __webpack_public_path__ + "img/Cheer Megaphone65.65707ce4.jpg";